/** @jsx jsx */
import { jsx } from '@emotion/core'
import { DateRange, Grid } from 'bold-ui'
import { subTipoRecord } from 'components/form/field/select/SubtipoAtendimentoSelectField/SubtipoAtendimentoSelectField'
import { format } from 'date-fns'

import { HistoricoAtendimentoAdvancedFilterFormModel } from '../../model/HistoricoAtendimentoModel'
import HistoricoAtendimentoFilterItem from './HistoricoAtendimentoFilterItem'

export interface HistoricoAtendimentoActiveFiltersProps {
  filters: HistoricoAtendimentoAdvancedFilterFormModel
}

const periodoText = (periodo: DateRange) =>
  `(${format(periodo.startDate, 'dd/MM/yyyy')} até ${format(periodo.endDate, 'dd/MM/yyyy')})`

export default function HistoricoAtendimentoActiveFilters({ filters }: HistoricoAtendimentoActiveFiltersProps) {
  const { periodo, subTipoAtendimento, cbo, equipe, profissional, medicamento, ciap2, cid10 } = filters

  return (
    <Grid alignItems='center' justifyContent='flex-start' gap={0.25} gapVertical={0.25} wrap={false}>
      {periodo && <HistoricoAtendimentoFilterItem label='Período' text={periodoText(periodo)} filters={filters} />}
      {subTipoAtendimento && (
        <HistoricoAtendimentoFilterItem
          label='Subtipo do atendimento'
          text={subTipoRecord[subTipoAtendimento]}
          filters={filters}
        />
      )}
      {cbo && <HistoricoAtendimentoFilterItem label='CBO' text={cbo.nome} filters={filters} />}
      {equipe && <HistoricoAtendimentoFilterItem label='Equipe' text={equipe.nome} filters={filters} />}
      {profissional && (
        <HistoricoAtendimentoFilterItem label='Profissional' text={profissional.nome} filters={filters} />
      )}
      {medicamento && (
        <HistoricoAtendimentoFilterItem label='Medicamento' text={medicamento.principioAtivo} filters={filters} />
      )}
      {ciap2 && <HistoricoAtendimentoFilterItem label='CIAP2' text={ciap2.nome} filters={filters} />}
      {cid10 && <HistoricoAtendimentoFilterItem label='CID10' text={cid10.nome} filters={filters} />}
    </Grid>
  )
}
